import { useRootPlaceBySlugQuery } from '~/libs/gql/queries/root_places/rootPlaceBySlugQuery.generated';
import type { MenuItemDishCategory } from '~/libs/gql/types';

type UseRootPlaceBySlugDataArgs = {
  dishCategory?: MenuItemDishCategory | null
  limit: number
  offset: number
  slug: string
  sortBy: string
  sortDir: string
}

export const useRootPlaceBySlugData = ({ dishCategory = null, limit, offset, slug, sortBy, sortDir }: UseRootPlaceBySlugDataArgs) => {
  const query = useRootPlaceBySlugQuery({
    variables: {
      dishCategory,
      pagination: {
        limit,
        offset,
        sortBy,
        sortDir,
      },
      slug,
    },
  });
  return query;
};
